import { useEffect } from "react";
import { useHistory } from "react-router";
import DefaultStoryImage from "../images/good-karma.png";
import Button from "../components/Button";
import SheWolf from "../images/corner/corner-shewolf.webp";
import { renderStrapiContent } from "../utils/contentfulOptions";
import StrapiImage from "../components/StrapiImage.js";
import FullPageLoader from "../components/FullPageLoader";

const getPlainText = (value) => {
  if (!value) return "";
  if (typeof value === "string") return value.replace(/\s+/g, " ").trim();
  if (Array.isArray(value)) {
    return value
      .map((item) => getPlainText(item))
      .filter(Boolean)
      .join(" ")
      .replace(/\s+/g, " ")
      .trim();
  }
  if (typeof value === "object") {
    return [value.text, getPlainText(value.children)]
      .filter(Boolean)
      .join(" ")
      .replace(/\s+/g, " ")
      .trim();
  }
  return "";
};

const excerpt = (text, max = 140) => {
  if (!text) return "";
  if (text.length <= max) return text;
  return text.slice(0, max).replace(/\s+\S*$/, "") + "…";
};

const MeetJulesScott = (props) => {
  const history = useHistory();

  useEffect(() => {
    document.title = "Auburn Road - Meet Jules and Scott";
    return () => {
      document.title = "Auburn Road Vineyards";
    };
  }, []);

  if (!props.info) {
    return <FullPageLoader />;
  }

  const stories = props.info.wine_stories || [];
  const mainImage = StrapiImage(props.info.mainImage);

  const getStoryPath = (item) => {
    const title = item.Title || item.title || "";
    const slug = title.replace(/\s/g, "-").toLowerCase();
    return "/" + (item.unique_url || slug).replace(/^\//, "");
  };

  const getStoryImage = (item) => {
    const image = StrapiImage(item?.story_image);
    if (!image) return DefaultStoryImage;
    if (typeof image === "string") return image || DefaultStoryImage;
    return DefaultStoryImage;
  };

  const getStoryBlurb = (item) => {
    const title = item.Title || item.title || "";
    const blurb = getPlainText(item.blurb);
    if (blurb && blurb !== title) return excerpt(blurb);
    const content = getPlainText(item.content);
    if (content && content !== title) return excerpt(content);
    return blurb;
  };

  return (
    <>
      <img className="corner-shewolf" src={SheWolf} alt="" />
      <div className="container meet-page p-t-100">
        <section className="meet-hero">
          <p className="meet-hero__kicker">Owners & founders</p>
          <h1 className="huge-text-no-quote meet-hero__title">Jules & Scott</h1>
          <p className="meet-hero__intro">
            Owners and founders of Auburn Road Vineyard and Winery since 2003, a
            partnership in wine, and in life.
          </p>
        </section>

        <section className="meet-story">
          {mainImage && (
            <div className="meet-story__media">
              <img
                className="meet-story__photo"
                src={mainImage}
                alt="Jules and Scott"
              />
            </div>
          )}
          <div className="meet-story__copy">
            {renderStrapiContent(props.info?.body)}
          </div>
        </section>

        {stories.length > 0 && (
          <section className="meet-related">
            <div className="meet-related__heading">
              <h2 className="huge-text-no-quote">More of the story</h2>
              <p className="meet-related__intro">
                A few Wine Stories if you want to read further.
              </p>
            </div>
            <div className="meet-related__list">
              {stories.map((story, index) => {
                const path = getStoryPath(story);
                const image = getStoryImage(story);
                const blurb = getStoryBlurb(story);
                return (
                  <article
                    className="wine-story-wrap story-card story-card--featured"
                    key={story.id || story.documentId || index}
                  >
                    <div
                      className="story-image pointer"
                      style={{ "--bg-image": `url(${image})` }}
                      onClick={() => history.push(path)}
                      role="presentation"
                    />
                    <div className="story-card__copy">
                      <h3
                        className="story-card__title pointer"
                        onClick={() => history.push(path)}
                      >
                        {story.Title || story.title}
                      </h3>
                      {blurb ? (
                        <p className="story-card__blurb blurb">{blurb}</p>
                      ) : null}
                      <Button
                        onClick={() => history.push(path)}
                        className="continue-reading"
                        small
                        type="plain"
                      >
                        Continue reading
                      </Button>
                    </div>
                  </article>
                );
              })}
            </div>
          </section>
        )}
      </div>
    </>
  );
};

export default MeetJulesScott;
